/**
 * @fileoverview POST handler for the "/engagement/report_builder_2/:app_group_id/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementReportBuilder2AppGroupIdUpdateArchivedStateProps,
  ReportBuilder2ArchiveResult,
} from "./types";

export const postReportBuilder2Archive = reactQueryMutationAdapter(
  engagementReportBuilder2AppGroupIdUpdateArchivedStateCacheKeys,
  (props: PostEngagementReportBuilder2AppGroupIdUpdateArchivedStateProps): Promise<ReportBuilder2ArchiveResult> => {
    return fetch(
      `/engagement/report_builder_2/${props.app_group_id}/update_archived_state`,
      "POST",
      props,
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
